import { TopBarActionButton, useSidePanelContext } from '@merchant-portal/framework'
import { IconHelp } from '@klarna/bubble-ui'
import { hooks as i18nHooks } from 'mage-i18n'
import React from 'react'
import styled from 'styled-components'
import { useHelpContext } from '../hooks'

const QuestionMarkButtonContainer = styled.div`
  position: relative;
  max-height: 40px;
`

function QuestionMarkButton () {
  const { isSidePanelOpen, setSidePanelOpen } = useSidePanelContext()
  const { close: closeHelptool, setIsOpen } = useHelpContext()
  const t = i18nHooks.useTranslator()

  const handleClick = () => {
    if (isSidePanelOpen) {
      closeHelptool()
      setSidePanelOpen(false)
    } else {
      setSidePanelOpen(true)
      setIsOpen(true)
    }
  }

  return (
    <QuestionMarkButtonContainer>
      <TopBarActionButton
        id='helpful-question-mark-button'
        toggled={isSidePanelOpen}
        label={t('help-tool.button-text')}
        Icon={IconHelp}
        onClick={handleClick}
      />
    </QuestionMarkButtonContainer>
  )
}

export default QuestionMarkButton
